import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgSevereIrritationSelectedEmojiSecondary(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M23.75 8C15.07 8 8 15.07 8 23.75S15.07 39.5 23.75 39.5 39.5 32.43 39.5 23.75 32.43 8 23.75 8Zm3.79 24.38c-.58 0-1.09-.14-1.63-.28-.63-.17-1.28-.35-2.19-.35-.91 0-1.54.18-2.15.35-.52.15-1.02.29-1.61.29a2.59 2.59 0 0 1 0-5.18c.58 0 1.04.13 1.53.28.6.17 1.21.35 2.22.35 1.01 0 1.69-.19 2.29-.36.5-.14.97-.27 1.54-.27a2.59 2.59 0 0 1 2.59 2.59c0 1.43-1.16 2.58-2.59 2.58Z",
    fill: "currentColor"
  }));
}

export { SvgSevereIrritationSelectedEmojiSecondary as default };
